import { createSlice } from "@reduxjs/toolkit";

const settingSlice = createSlice({
    name: "setting",
    initialState: {
        message: null,
        error: null,
        configuration:[],
        appConfiguration:[]
    },
    reducers: {
        saveAddress: () => { },
        saveWhatsAppNo: () => { },
        saveMinimumOrderQty: () => { },
        savePaymentMode: () => { },
        savePaymentGateway: () => { },
        saveSipMode: () => { },
        saveSipStatus: () => { },
        addSms: ()=>{ },
        saveKycStatus: () => { },
        getConfiguration: () => { },
        bulkDiamondPointGiftByFileRequest: () => {},
        bulkDiamondPointGiftByPhoneRequest:()=>{},
        saveDiamondPointsExpireRequest: () => {},
        saveDiamondPointsAmountConfigRequest:()=>{},
        setConfiguration: (state,action) => {
            state.configuration = action.payload;
         },
         getAppConfiguration: () => { },
         setAppConfiguration: (state,action) => {
            state.appConfiguration = action.payload;
         },
         updateAppConfigFields: () => { },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearMessage: (state) => {
            state.error = null;
            state.message = null;
        }
    }
});

export const {
    saveAddress,
    saveWhatsAppNo,
    saveMinimumOrderQty,
    savePaymentMode,
    savePaymentGateway,
    saveSipMode,
    saveSipStatus,
    addSms,
    saveKycStatus,
    setMessage,
    setError,
    clearMessage,
    getConfiguration,
    setConfiguration,
    getAppConfiguration,
    setAppConfiguration,
    updateAppConfigFields,
    bulkDiamondPointGiftByFileRequest,
    bulkDiamondPointGiftByPhoneRequest,
    saveDiamondPointsExpireRequest, 
    saveDiamondPointsAmountConfigRequest,

} = settingSlice.actions;

export default settingSlice.reducer;
